import React from 'react';
import { Card as CardComponent } from 'theme-ui';
import { Layout, Stack, Main } from '@layout';
import CardList from '@components/CardList';
import Card from '@components/Card';
import Divider from '@components/Divider';
import Seo from '@widgets/Seo';
import AuthorExpanded from '@widgets/AuthorExpanded';
import { PostComments } from '@widgets/Post';

const COUNTRIES = { it: 'Italia', uk: 'UK', es: 'España', us: 'US' };

const Question = (props) => {
  const {
    data: { site, question, categoryQuestions },
  } = props;
  const relatedquestions = [
    ...(categoryQuestions ? categoryQuestions.nodes : []),
  ];
  const {
    locale,
    siteUrl,
    app: { baseUrl },
  } = site.siteMetadata;
  const fullSiteUrl = `${siteUrl}/${locale}`;
  const { pageContext: { services = {} } = {} } = props;
  const { GATSBY_BUILD_LANGUAGE } = process.env;
  return (
    <Layout {...props}>
      <Seo
        {...question}
        siteUrl={fullSiteUrl}
        baseUrl={baseUrl}
        appended={COUNTRIES[GATSBY_BUILD_LANGUAGE || locale]}
        logo={
          props.data.allBlockContent.nodes.find(
            (item) => item.identifier === 'footer'
          ).images[1]
        }
      />
      <Stack effectProps={{ effect: 'fadeInDown' }}>
        <Main>
          <Card {...question} variant='horizontal-hero' omitExcerpt omitMedia />
        </Main>
      </Stack>
      <Divider space={3} />
      <Stack effectProps={{ fraction: 0 }}>
        <Main>
          <CardComponent variant='paper-lg'>
            {services.disqus && <PostComments {...question} />}
          </CardComponent>
          <Divider />
          <AuthorExpanded author={question.author} />
          <Divider />
          {question.category && (
            <CardList
              title='Related questions'
              nodes={relatedquestions}
              variant={['horizontal-md']}
              columns={[1, 2, 2, 2]}
              limit={6}
              distinct
            />
          )}
        </Main>
      </Stack>
    </Layout>
  );
};

export default Question;
